<template lang="pug">
  div(class="eyecatch-block")
    h1(class="title")
      img(src="~images/Event/Infographics/eyecatch_text.png")

    div(class="description")
      | 2018年6月4日にサービスをリリースしてから
      br(class="smOnly")
      | 1年半が経ちました。
      br
      | 地域への移住を希望する登録者が1万人を突破し、
      br
      | 多くの方から地域への訪問、
      br
      | そして移住の報告をいただいています。
      br
      | 1万人突破の節目にSMOUTの今を公開します。
    div(class="share")
      a(:href="facebookShareUrl", target="_blank", class="shareItem")
        img(src="~images/Event/Infographics/facebook.png")
      a(:href="twitterShareUrl", target="_blank", class="shareItem")
        img(src="~images/Event/Infographics/twitter.png")
</template>
<script>
  import LogoIcon from 'images/svg/logo.svg';

  export default {
    components: {
      LogoIcon,
    },
    data() {
      const ogpTitle = '移住したい人1万人突破！ | 地域への移住と関係人口のマッチング SMOUT（スマウト）';
      return {
        facebookShareUrl: 'https://www.facebook.com/dialog/share?app_id=2016611608613190&display=popup&href=https://smout.jp/event/infographics',
        twitterShareUrl: `https://twitter.com/intent/tweet?text=${encodeURI(ogpTitle)}&url=${encodeURIComponent('https://smout.jp/event/infographics')}&hashtags=インフォグラフィック,SMOUT&via=smoutjp`,
      };
    },
  };
</script>
<style lang="scss" scoped>
  @import 'stylesheets/pages/event/infographics/_variables.scss';

  .smOnly {
    @include mq('sm') {
      display: none;
    }
  }

  .eyecatch-block {
    text-align: center;
    overflow: hidden;
    padding-top: 110px;
    padding-bottom: 90px;
    background-image: url('~images/Event/Infographics/eyecatch_background.svg?file'),
                      url('~images/Event/Infographics/background_1@2x.png'),
                      url('~images/Event/Infographics/background_2@2x.png'),
                      url('~images/Event/Infographics/background_3@2x.png'),
                      url('~images/Event/Infographics/background_4@2x.png'),
                      url('~images/Event/Infographics/background_5@2x.png'),
                      url('~images/Event/Infographics/background_6@2x.png');
    background-repeat: no-repeat;
    background-position: center,
                        top 60px left 9%,
                        bottom 80px right 6%,
                        top 90px right 8%,
                        bottom 48% left 4%,
                        bottom 90px left 8%,
                        bottom 56% right 4%;
    background-size: 500px,
                     70px,
                     80px,
                     67.3px,
                     70px,
                     84.5px,
                     56.3px;
    @include mq('sm') {
      padding-top: 170px;
      padding-bottom: 120px;
      background-size: 660px,
                      140px,
                      160px,
                      134.6px,
                      140px,
                      169px,
                      112.6px;
    }
    @include mq('md') {
      padding-top: 170px;
      padding-bottom: 120px;
      background-size:
                      760px,
                      190px,
                      200px,
                      172px,
                      178px,
                      266px,
                      170px;
    }
  }
  .title {
    text-align: center;
    margin-bottom: 20px;
    img {
      max-width: 460px;
      width: 100%;
      @include mq('sm') {
        max-width: 580px;
      }
      @include mq {
        max-width: 760px;
      }
    }
  }
  .description {
    text-align: center;
    font-size: 1.2rem;
    font-weight: 300;
    line-height: 1.8;
    @include mq('sm') {
      font-size: 1.4rem;
    }
  }
  .share {
    margin-top: 10px;
    @include mq('sm') {
      margin-top: 30px;
    }
  }
  .shareItem {
    display: inline-block;
    width: 40px;
    height: 40px;
    margin-left: 10px;
    margin-right: 10px;
    @include mq('sm') {
      width: 50px;
      height: 50px;
    }
  }
</style>
